// extracted by mini-css-extract-plugin
module.exports = {"loaderBackgroundContainer":"CubeLoader_loaderBackgroundContainer__2cjPN","cubeLoader":"CubeLoader_cubeLoader__3I51P","screenReaderOnly":"CubeLoader_screenReaderOnly__3G7w0"};